<template>
  <div class="max_box">
    
    
  <van-tabbar v-model="type" @change="onChange" active-color="#9231f5" inactive-color="#6b7db2" style="border-top: 1px solid #9231f5; box-sizing: border-box; background-color: rgb(243, 246, 255); z-index: 200">
    
    
    <van-tabbar-item>
      <span>首页</span>
      <template #icon="props">
        <img :class="{no:!props.active}" :src="props.active ? '/static/image/dt.png' : '/static/image/tabbar_icon1_nor.png'" />
      </template>
    </van-tabbar-item>

    <van-tabbar-item>
      <span>发现</span>
      <template #icon="props">
        <img :class="{no:!props.active}" :src="props.active ? '/static/image/fx.png' : '/static/image/tabbar_icon6_nor.png'" />
      </template>
    </van-tabbar-item>

    <van-tabbar-item>
      <span>优惠</span>
      <template #icon="props">
        <img :class="{no:!props.active}" :src="props.active ? '/static/image/yh.png' : '/static/image/tabbar_icon3_nor.png'" />
      </template>
    </van-tabbar-item>
    
    
    <van-tabbar-item>
      <span>我的</span>
      <template #icon="props">
        <img :class="{no:!props.active}" :src="props.active ? '/static/image/wd.png' : '/static/image/tabbar_icon5_nor.png'" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
  <!-- <div class="colosline"></div> -->
</div>
</template>
<script>
//
export default {
  name: 'Foot',
  data() {
    return { type: 0 };
  },
  methods: {
    onChange(type) {
      console.log(type);
      
      let that = this;
      if (type == 0) {
        // that.$parent.goNav(`/`);
           that.$parent.goNav(`/`);
      }
      if (type == 1) {
        // that.$parent.goNav(`/activity`);
        // that.$parent.goNav(`/home`);
          that.$parent.goNav(`/discover`);
      }
      if (type == 2) {
        // that.$parent.openKefu();
       that.$parent.goNav(`/activity`);
      }
      if (type == 3) {
          that.$parent.goNav(`/mine`);
        
        // that.$parent.goNav(`/zhanzhu`);
      }
      if (type == 4) {
     
        // that.$parent.goNav(`/mine`);
      }
    },
    changPath() {
      let that = this;
      let path = this.$route.path;
      if (path == '/') {
        that.type = 0;
      }
      if (path == '/home') {
        that.type = 0;
      }if (path == '/discover') {
        that.type = 1;
      }

      if (path == '/activity') {
        that.type = 2;
      }
      if (path == '/mine') {
        that.type = 3;
      }
      // if (path == '/mine') {
      //   that.type = 4;
      // }
      // if (path == '/gamePage' || path == '/hongbao') {
      //   that.type = 5;
      // }
    },
  },
  mounted() {},
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.changPath();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '../../../static/css/chunk-611499bd.2ebefcf0.css';
.van-tabbar-item__icon img {
  display: block;
  height: 20px;
  margin-bottom: 6px;
}
.van-tabbar-item__icon .no{
  height: 20px;
  margin-bottom: 6px;
}
.van-tabbar-item {
  font-size: 14px;
}
.van-tabbar {
  height: 1.50667rem;
}
.van-tabbar-item--active {
  background-color: rgb(243, 246, 255);
}
.colosline{
    width: 100%;
    height: 2px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 300;
    // background: -webkit-linear-gradient(left, #f08448, #ffce70, #f08449);
    background: linear-gradient(90deg, #f08448, #ffce70, #f08449);
}
.max_box{
  height: 52px;
}

</style>



// WEBPACK FOOTER //
// src/components/libs/Foot.vue